import DateRangePersistentService from 'nightwatch-web/services/persistence/date-range';

export default class PinnedItemsService extends DateRangePersistentService {
  RANGE_KEY = 'nw:pinned-items:date-range';
  DEFAULT_TYPE = '2_weeks';
}
